<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('rating_edit.title') }}</h1>
      <rating-form :id="id" :colony="colony" :apiary="apiary"></rating-form>
    </b-container>
  </div>
</template>

<script>
import RatingForm from '../components/RatingForm'
export default {
  name: 'RatingEdit',
  props: ['id', 'apiary', 'colony'],
  components: { RatingForm }
}
</script>

<style scoped>

</style>
